export default {
  'menu.home': 'Home',
  'menu.login': 'Log in',
  'menu.register': 'Sign up',
  'menu.account.logout': 'Logout',
  'menu.findPassword': 'Find password',
  'menu.about': 'About',
  'menu.product':'Product',
  'menu.product.challenge-rules':'Challenge Rules',
  'menu.product.elite-competition':'Elite Competition',
  'menu.product.personal-challenge':'Personal Challenge',
  'menu.product.month-challenge':'Monthly Challenge ',
  'menu.develop':'Develop',
  'menu.develop.partnership-program':'Partnership Program',
  'menu.develop.trader-recruitment':'Trader Recruitment',
  'menu.download':'Download',
  'menu.FAQ':'FAQ',
  'menu.FAQ.list':'FAQ List',
  'menu.FAQ.detail':'FAQ Details',
  'menu.account': 'Individual Center',
  'menu.account.personal': 'Profile',
  'menu.account.instrument-panel': 'Dashboard',
  'menu.account.instrument-panel-detail': 'Details',
  'menu.account.product': 'Product',
  'menu.account.purchaseEvaluation': 'Purchase',
  'menu.account.earn': 'Points',
  'menu.account.earn.integral': 'Integral Details',
  'menu.account.earn.product': 'Product redemption',
  'menu.account.earn.invitation': 'Invite Record',
  'menu.account.earn.commission': 'Commission Details',
  'menu.account.payout': 'Payout',
  'menu.account.payout.transfer': 'Transfer',
  'menu.account.payout.transferList': 'Transfer Record',
  'menu.account.payout.withdrawal': 'Withdrawal',
  'menu.account.payout.withdrawalList': 'Withdrawal Record',
  'menu.account.payout.withdrawalDetails': 'Withdrawal Details',
  'menu.account.payout.inAndOutAccountList': 'Entry And Exit Records',
  'menu.account.my': 'My',
  'menu.account.my.personal': 'Profile',
  'menu.account.my.accountInfo': 'Account Information',
  'menu.account.my.certification': 'Certification',
  'menu.account.my.certificate': 'Certificate',
  'menu.account.my.order': 'Order List',
  'menu.account.my.contactUs': 'Contact Us',
  'menu.account.my.orderDetail': 'Order Details',
  'menu.account.my.findPassword': 'Find password',


  'menu.admin': 'Admin',
  'menu.admin.sub-page': 'Sub-Page',
  'menu.welcome': 'Welcome',
  'menu.more-blocks': 'More Blocks',
  'menu.register-result': 'Register Result',
  'menu.dashboard': 'Dashboard',
  'menu.dashboard.analysis': 'Analysis',
  'menu.dashboard.monitor': 'Monitor',
  'menu.dashboard.workplace': 'Workplace',
  'menu.exception.403': '403',
  'menu.exception.404': '404',
  'menu.exception.500': '500',
  'menu.form': 'Form',
  'menu.form.basic-form': 'Basic Form',
  'menu.form.step-form': 'Step Form',
  'menu.form.step-form.info': 'Step Form(write transfer information)',
  'menu.form.step-form.confirm': 'Step Form(confirm transfer information)',
  'menu.form.step-form.result': 'Step Form(finished)',
  'menu.form.advanced-form': 'Advanced Form',
  'menu.list': 'List',
  'menu.list.table-list': 'Search Table',
  'menu.list.basic-list': 'Basic List',
  'menu.list.card-list': 'Card List',
  'menu.list.search-list': 'Search List',
  'menu.list.search-list.articles': 'Search List(articles)',
  'menu.list.search-list.projects': 'Search List(projects)',
  'menu.list.search-list.applications': 'Search List(applications)',
  'menu.profile': 'Profile',
  'menu.profile.basic': 'Basic Profile',
  'menu.profile.advanced': 'Advanced Profile',
  'menu.result': 'Result',
  'menu.result.success': 'Success',
  'menu.result.fail': 'Fail',
  'menu.exception': 'Exception',
  'menu.exception.not-permission': '403',
  'menu.exception.not-find': '404',
  'menu.exception.server-error': '500',
  'menu.exception.trigger': 'Trigger',
  'menu.account.settings': 'Account Settings',
  'menu.account.trigger': 'Trigger Error',
  'menu.editor': 'Graphic Editor',
  'menu.editor.flow': 'Flow Editor',
  'menu.editor.mind': 'Mind Editor',
  'menu.editor.koni': 'Koni Editor',
    'menu.mine': 'Mine',
};
